export const SET_MAINTENANCE_MODE_WEB = "set-maintenance-mode-web";
export const SET_UNSUBSCRIBE = "setObserver";
